<div class="background-image-container">
  <div class="container">

    <div class="jumbotron jumbotron-fluid">
      <div class="d-flex flex-wrap">
        <div>
          <h1 class="display-3">Repositorio Centro de Altos Estudios Nacionales</h1>

        </div>
      </div>

    </div>
  </div>
  <picture class="background-image">
    <source type="image/webp" srcset="assets/caen/images/banner.webp 2000w, assets/caen/images/banner-half.webp 1200w, assets/caen/images/banner-tall.webp 768w">
    <source type="image/jpg" srcset="assets/caen/images/banner.jpg 2000w, assets/caen/images/banner-half.jpg 1200w, assets/caen/images/banner-tall.jpg 768w">
    <img alt="" [src]="'assets/caen/images/banner.jpg'"/><!-- without the []="''" Firefox downloads both the fallback and the resolved image -->
  </picture>
  <aside class="background-image-overlay">
    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <h2 class="display-4">Repositorio de documentos</h2>
          <p class="lead">El repositorio de documentos del Centro de Altos Estudios Nacionales (CAEN) es un espacio virtual que permite el acceso a la información de los documentos producidos por el CAEN, así como a los documentos de interés para la comunidad académica y el público en general.</p>
        </div>
      </div>
    </div>
  </aside>
</div>
